import { render } from "./book-detail-skeleton.vue?vue&type=template&id=607e0643&scoped=true"
import script from "./book-detail-skeleton.vue?vue&type=script&lang=js"
export * from "./book-detail-skeleton.vue?vue&type=script&lang=js"

import "./book-detail-skeleton.vue?vue&type=style&index=0&id=607e0643&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607e0643"]])

export default __exports__